/* eslint-disable */
export default {
  bind(el, binding) {
    const input = el.querySelector('input')
    if (!input) return
    
    // 是否实时处理（默认 blur 时处理）
    const isRealtime = binding.modifiers.realtime
    
    const handler = function(event) {
      const oldValue = this.value
      const newValue = oldValue.trim()
      
      if (newValue !== oldValue) {
        this.value = newValue
        // 触发 input 事件让 v-model 更新
        const inputEvent = new Event('input', { bubbles: true })
        this.dispatchEvent(inputEvent)
        
        // 对于 change 事件也需要触发
        if (event.type === 'blur') {
          const changeEvent = new Event('change', { bubbles: true })
          this.dispatchEvent(changeEvent)
        }
      }
    }
    
    input.addEventListener('blur', handler)
    if (isRealtime) {
      input.addEventListener('input', handler)
    }
    
    // 保存处理函数以便解绑
    el._trimHandler = handler
  },
  
  unbind(el) {
    const input = el.querySelector('input')
    if (input && el._trimHandler) {
      input.removeEventListener('blur', el._trimHandler)
      input.removeEventListener('input', el._trimHandler)
    }
  }
}